/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef } from "react";
import { Link, useHistory } from "react-router-dom";
import { useScreenSize } from "../../../utils/media-query";
import { Button } from "devextreme-react";
import Toolbar, { Item } from "devextreme-react/toolbar";
import LoadPanel from "devextreme-react/load-panel";
import FormApprovalSetting from "./FormApprovalSetting";
import { useSelector, useDispatch } from "react-redux";
import { responseMiddleware } from "../../../redux/reducers";
import { IsPermisionPathRequired } from "../../../redux/actions";
import "./style.scss";
import { getParentPath, guidEmpty, axios } from "../../../common";
import UsingIntl from "../../../services/using_intl";
import { formatMessage } from "devextreme/localization";
import DataGridApproval from "../ApprovalDataGridCommon";
import notify from "devextreme/ui/notify";

export default function ApprovalSettingCreate() {
  const history = useHistory();
  const { isXSmall, isSmall } = useScreenSize();
  const formData = useRef({
    IsActive: true,
    Description: "",
  });
  const [approvalSelected] = React.useState([]);
  const dispatch = useDispatch();
  const { middlewarePath: middleware, loading } =
    useSelector(responseMiddleware);
  const PARENT_PATH = getParentPath();

  useEffect(() => {
    UsingIntl("P0006");
    dispatch(IsPermisionPathRequired(PARENT_PATH));
  }, [dispatch]);

  useEffect(() => {
    if (middleware) {
      const { NavigateState, CreateState } = middleware;
      if (NavigateState !== undefined && !NavigateState) {
        history.push("/403");
        return;
      }
      if (CreateState !== undefined && !CreateState) {
        history.push("/403");
        return;
      }
    }
  }, [middleware]);

  const handleSaveApprovalSetting = async () => {
    if (!approvalSelected) {
      notify("Vui lòng nhập đủ thông tin", "warning", 2000);
      return;
    }
    const hasLevel1 = approvalSelected.some(
      (approval) => approval.ApprovalLevel === 1
    );

    if (!hasLevel1) {
      // Return an error message or perform some error handling
      notify("Vui lòng nhập cấp 1 ", "warning", 2000);
      return;
    }
    const newApprovers = approvalSelected.map((item) => {
      return {
        Oid: guidEmpty,
        ApprovalSettingOid: guidEmpty,
        EmployeeOid: item.Employee.Oid,
        ApprovalLevel: item.ApprovalLevel,
        Description: item.Description,
      };
    });
    const payload = {
      ...formData.current,
      ApprovalSettingLevels: newApprovers,
    };
    const { data } = await axios.post("ApprovalSettingDepartment", payload, {
      headers: {
        MappedState: 2,
      },
    });
    if (!data) {
      notify("Thêm mới thất bại", "error", 2000);
      return;
    }
    notify("Thêm mới thành công", "success", 2000);
    history.push("/approval/approval-setting-department/list");
  };

  return (
    <div>
      <LoadPanel visible={loading} />
      {/* Breadcrumb */}
      <div className={"breadcrumb"}>
        <div className={"breadcrumb-left"}>
          <div className={"breadcrumb-page-title"}>
            {formatMessage("ApprovalSettingDepartmentCreate")}
          </div>
        </div>
        <div className={"breadcrumb-right"}>
          <Link
            to="/approval/approval-setting-department/list"
            className={"breadcrumb-item"}
          >
            {formatMessage("Approval")}
          </Link>
          <span className={"breadcrumb-item active"}>
            {formatMessage("ApprovalSettingDepartmentCreate")}
          </span>
        </div>
      </div>

      <div className={"section"}>
        <div className={"section-heading has-page-title"}>
          <h4 className={"page-title"}>{""}</h4>
          <div className={`page-actions`}>
            <Toolbar>
              <Item
                location="after"
                locateInMenu={isXSmall || isSmall ? "always" : "auto"}
                cssClass={"datagrid-toolbar-actions-dropdown"}
              >
                <Button
                  icon="save"
                  text={formatMessage("Save")}
                  type="default"
                  stylingMode="outlined"
                  className="mr-1"
                  onClick={handleSaveApprovalSetting}
                />
                <Button
                  icon="close"
                  text={formatMessage("Cancel")}
                  className="mr-1"
                  onClick={() =>
                    history.push("/approval/approval-setting-department/list")
                  }
                />
              </Item>
            </Toolbar>
          </div>
        </div>
        <div className={"section-body"}>
          <h4 className={"section-subtitle md-4"}>
            {formatMessage("ApprovalSettingDepartmentCreate")}
          </h4>
          <FormApprovalSetting formData={formData} />
          <div className="mt-4">
            <h4 className={"section-subtitle"}>{formatMessage("Approvers")}</h4>
            <DataGridApproval approvalSelected={approvalSelected} />
          </div>
        </div>
      </div>
    </div>
  );
}
